import { Component, ViewEncapsulation, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsService } from '@irb/irb-clients/irb-clients.service';
import { IrbClientsEvents, IrbAppEvents } from '@irb-common/events';
import { UtilityService } from '@irb-common/services/utility.service';
import {interval, Subscription} from "rxjs";

@Component({ standalone: false,
  selector: 'irb-import-portfolio-names-dialog',
  templateUrl: './import-portfolio-names-dialog.component.html',
  styleUrls: ['./import-portfolio-names-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportPortfolioNamesDialogComponent implements OnInit {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string;
  isUiTest: boolean = false;
  checkPortfolioNamesSub: Subscription;
  constructor(
    public dialogRef: MatDialogRef<ImportPortfolioNamesDialogComponent>,
    public as: AppService,
    public cs: IrbClientsService,
    private util: UtilityService
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportPortfolioName0', this.file, this.file.name);
    
    this.cs.importPortfolioNames(f).subscribe({
      next: (res: any) => {
        const response = (typeof res === "string") ? JSON.parse(res) : res;
        if (response?.responseStatus ==='SUCCESS') {
          //this.triggerMaxFileUploadSizeExceededError();
          this.checkImportPortfolioNamesAsyncStatus(response.responseUtilityMap.statusId);
        } else {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Portfolio Names',
            detail: 'An error occurred processing your request.'
          });
        }
      }, error: () => {}
    });
  }
  checkImportPortfolioNamesAsyncStatus(importStatusId: string) {
    const intervalValue = this.isUiTest ? 0 : 3000;
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.checkPortfolioNamesSub = interval(intervalValue).subscribe(() => {
      this.cs.importPortfolioNamesStatus(importStatusId).subscribe((response: any) => {
        if (response.responseUtilityMap?.requestStatus?.toUpperCase() === "COMPLETED") {
          this.checkPortfolioNamesSub.unsubscribe();
          this.importPortfolioNamesComplete(response.responseData);
        } else if(response.responseStatus !== "SUCCESS" ||
          (response.responseUtilityMap?.requestStatus && response.responseUtilityMap?.requestStatus?.toUpperCase() === "FAILED")) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Portfolio Names',
            detail: "An error occurred processing your request."
          });
          this.checkPortfolioNamesSub.unsubscribe();
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        } else if(response.responseUtilityMap?.actionStatus?.reqStatus?.toUpperCase() === "IN_PROGRESS") {
        }
      }, () => {
        this.checkPortfolioNamesSub.unsubscribe();
      });
    });
  }
  importPortfolioNamesComplete(res: any) {
    const response = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));

    if(response.status && response.status === "fail") {
      if(response.message) {
        this.errorMessage = response.message;
      } else {
        this.isValidFile = false;
      }
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      return;
    }

    const hasValidRecords = (response.validRecords && response.validRecords.length > 0);
    const hasInvalidRecords = (response.invalidRecords && response.invalidRecords.length > 0);

    if(hasValidRecords && !hasInvalidRecords) {
      this.as.fireEvent(IrbClientsEvents.IMPORT_PORTFOLIO_NAMES_COMPLETE, response);
    } else if(!hasValidRecords && !hasInvalidRecords) {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'warn',
        summary: 'Import Portfolio Names',
        detail: 'The import completed without any names being updated.'
      });
    } else if(hasInvalidRecords) {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_PORTFOLIO_NAMES_RESULT, response);
    }

    this.close();

  }
}
